const IconCode = {
    facebook: "entypo-social:facebook", //mingcute:facebook-fill,
    instagram: "entypo-social:instagram", //ri:instagram-fill,
    linkedin: "entypo-social:linkedin", //entypo-social:linkedin-with-circle,
    pinterest: "entypo-social:pinterest", //entypo-social:pinterest-with-circle,
    twitter: "entypo-social:twitter", //formkit:twitter,
    youtube: "entypo-social:youtube", //line-md:youtube-filled,
    invoice: "healthicons:bills", //stash:invoice,
    currencyNotes: "healthicons:bills-outline",
    reportDownload: "healthicons:clinical-f-outline", //line-md:downloading-loop,
    dataSecurity: "healthicons:health-data-security", //healthicons:data-security,
    healthPackage: "healthicons:health-data-security", //healthicons:health-data-security
    reportTat: "healthicons:i-schedule-school-date-time", //streamline:medical-files-report-history,
    home: "healthicons:home-alt-outline", //healthicons:home-alt-outline,
    hospital: "healthicons:hospital", //hugeicons:hospital-01,
    healthiconsHospital: "healthicons:hospital", //healthicons:hospital,
    paramter: "healthicons:lab-search", //covid:virus-lab-research-test-tube,
    labMarker1: "healthicons:lab-search", //hugeicons:labs,
    searchAdd: "healthicons:medical-search", //hugeicons:search-add,
    searchMedical: "healthicons:medical-search", //healthicons:medical-search,
    doctorPrescription: "healthicons:prescription-document-outline",
    testResult: "healthicons:rdt-result", //healthicons:rdt-result,
    userProfile: "healthicons:ui-user-profile-outline", //solar:user-line-duotone,
    arrowUpCircle: "material-symbols:arrow-circle-up-rounded", //heroicons:arrow-up-circle
    bolt: "material-symbols:bolt-rounded", //heroicons:bolt-16-solid
    trusted: "material-symbols:verified", //heroicons:check-badge
    onsStopHub: "material-symbols:widget-small-rounded", //heroicons:cube-transparent
    rupeeSolidCircle: "material-symbols:currency-rupee-circle-rounded", //heroicons:currency-rupee
    globeAsia: "material-symbols:globe-asia", //heroicons:globe-alt
    alert: "line-md:alert-loop", //eva:alert-triangle-fill,
    dangerTriangle: "line-md:alert-loop", //solar:danger-triangle-bold,
    danger: "line-md:alert-loop", //solar:danger-bold,
    alert2: "line-md:alert-loop", //line-md:alert-twotone,
    birthday: "line-md:calendar", //hugeicons:birthday-cake,
    orderDetail: "line-md:clipboard-list-twotone", //line-md:clipboard-list-twotone,
    download: "line-md:downloading-loop", //ion:cloud-download-outline,
    documentAdd: "line-md:document-add",
    filePlus: "line-md:file-plus-filled", //teenyicons:file-plus-solid,
    eye: "line-md:file-download-filled", //meteor-icons:eye,
    healthGraph: "line-md:gauge-loop", //material-symbols-light:health-metrics-outline-sharp,
    loadingTwoTone: "line-md:loading-twotone-loop", //line-md:loading-twotone-loop,
    phoneCall: "line-md:phone-call-loop", //line-md:phone-call-loop,
    phoneCall: "line-md:phone-call-loop", //line-md:phone-call,
    plus: "line-md:plus", //line-md:plus,
    addedToCart: "line-md:check-all", //hugeicons:test-tube-02,
    userIcon: "material-symbols:account-circle", //hugeicons:user-status,
    addPlua: "material-symbols:add", //fa-solid:plus,
    cart: "material-symbols:add-shopping-cart-rounded", //mynaui:cart-plus,
    upArrow: "material-symbols:arrow-forward-ios-rounded", //eva:arrow-ios-forward-fill,
    arrowRight: "material-symbols:arrow-forward-ios-rounded", //ep:arrow-right-bold,
    calender: "material-symbols:calendar-month", //simple-line-icons:calender,
    date: "material-symbols:calendar-month", //stash:data-date-light,
    mobile: "material-symbols:call-outline", //fluent:call-16-regular,
    transfer: "material-symbols:change-circle-outline-rounded", //mingcute:transfer-fill,
    unCheckBox: "material-symbols:check-box-outline-blank", //proicons:checkbox-unchecked,
    checkedBox: "material-symbols:check-box-rounded", //fluent:checkbox-checked-16-filled,
    checkmark: "material-symbols:check-circle-outline-rounded", //eva:checkmark-circle-2-fill,
    checkCircle: "material-symbols:check-circle-rounded", //solar:check-circle-bold,
    check: "material-symbols:check-rounded", //tabler:check,
    close: "material-symbols:close-rounded", //majesticons:close-line,
    upload: "material-symbols:cloud-upload", //ep:upload-filled,
    copy: "material-symbols:content-copy", //mage:copy-fill,
    team: "material-symbols:crowdsource", //fluent:people-team-32-regular,
    rupeeBold: "material-symbols:currency-rupee", //ic:baseline-currency-rupee,
    rupeeLight: "material-symbols:currency-rupee", //material-symbols-light:currency-rupee,
    deleteFilled: "material-symbols:delete", //ant-design:delete-filled,
    delete: "material-symbols:delete-outline-rounded", //wpf:delete,
    mapMarker: "material-symbols:directions", //line-md:map-marker-radius-twotone,
    file2: "material-symbols:docs-outline", //hugeicons:file-01,
    edit: "material-symbols:edit-outline", //fluent:edit-28-regular,
    error: "material-symbols:error-outline-rounded", //material-symbols:error-outline-rounded,
    track: "material-symbols:eye-tracking-outline-sharp", //material-symbols:eye-tracking-outline-sharp,
    compliant: "material-symbols:feedback-outline", //hugeicons:complaint,
    femaleGender: "material-symbols:female", //ph:gender-female-bold,
    quotesLeft: "material-symbols:format-quote", //icomoon-free:quotes-left,
    handshake: "material-symbols:handshake",
    hub: "material-symbols:hub-outline", //material-symbols:hub-outline,
    biInfoCircle: "material-symbols:info-outline-rounded", //bi:info-circle,
    info: "material-symbols:info-rounded", //eva:info-fill,
    info2: "ci:info",
    infoCircle: "material-symbols:info-rounded", //solar:info-circle-bold,
    chevronDown: "material-symbols:keyboard-arrow-down", //mdi:chevron-down,
    arrowDown: "material-symbols:keyboard-arrow-down-rounded", //iconamoon:arrow-down-2,
    downArrow: "material-symbols:keyboard-arrow-down-rounded", //eva:arrow-ios-downward-fill,
    outlinedLocation: "material-symbols:location-on-outline", //material-symbols-light:location-on-outline,
    mapTo: "material-symbols:location-on-outline-rounded", //hugeicons:location-01,
    directionTo: "material-symbols:location-on-outline-rounded", //hugeicons:location-04,
    logout: "material-symbols:logout", //majesticons:logout-half-circle-line,
    mail: "material-symbols:mail-outline", //hugeicons:mail-01,
    maleGender: "material-symbols:male", //ph:gender-male-bold,
    accountSetting: "material-symbols:manage-accounts", //hugeicons:account-setting-01,
    hamburger: "material-symbols:menu-rounded", //solar:hamburger-menu-linear,
    money: "material-symbols:money-bag-outline", //game-icons:receive-money,
    more: "material-symbols:more-vert", //ri:more-2-fill,
    location: "material-symbols:my-location", //mage:location,
    locate: "material-symbols:my-location", //mdi:my-location,
    navigationArrowCircle:
        "material-symbols:assistant-navigation-outline-rounded",
    technology: "material-symbols:network-intel-node", //hugeicons:nano-technology,
    offer: "material-symbols:percent-rounded", //lineicons:offer,
    locationPin: "material-symbols:pin-drop-outline-rounded", //f7:map-pin-ellipse,
    minus: "material-symbols:remove", //fa-solid:minus,
    minus: "material-symbols:remove", //pajamas:dash,
    search: "material-symbols:search-rounded", //hugeicons:search-02,
    satisfied: "material-symbols:sentiment-very-satisfied", //material-symbols-light:sentiment-very-satisfied-outline,
    time: "material-symbols:timer-outline-rounded", //mingcute:time-duration-fill,
    trendingUp: "material-symbols:trending-up-rounded",
    update: "material-symbols:update-rounded", //ic:round-update,
    mdiUpload: "material-symbols:upload", //mdi:upload,
    trust: "material-symbols:verified-outline", //hugeicons:checkmark-badge-02,
    labMarker2: "medical-icon:i-cath-lab", //medical-icon:i-mri-pet,
    blogger: "tabler:brand-blogger", //tabler:brand-whatsapp,
    whatsapp: "tabler:brand-whatsapp", //tabler:brand-whatsapp,
    fileTickSolid: "tabler:file-check", //teenyicons:file-tick-solid,
    order: "tabler:file-invoice", //lets-icons:order-light,
    raise: "tabler:hand-stop", //fluent-emoji-high-contrast:raised-back-of-hand,
    dot: "tabler:point-filled", //radix-icons:dot-filled,
    file: "tabler:report-analytics", //mdi:file-report-outline,
    ticket: "tabler:ticket", //f7:ticket,
    backArrow: "material-symbols:arrow-back-rounded",
    forwardArrow: "material-symbols:arrow-forward-rounded",
    notification: "mingcute:notification-newdot-fill",
    job: "hugeicons:permanent-job",
    linkedIn: "entypo-social:linkedin",
    naukri: "arcticons:naukricom",
    externalLink: "fluent-color:link-multiple-16",
    googleMapPin: "simple-icons:googlemaps",
    description: "tabler:file-description",
    grid: "flowbite:grid-outline",
    list: "grommet-icons:list",
    arrowRight2: "eva:arrow-right-outline",
    arrowLeft2: "eva:arrow-left-outline",
    loader: "codex:loader",
};
export default IconCode;
